<template>
  <Breadcrumbs title="" main="Pages" />
  <div class="container-fluid">
    <div class="faq-wrap">
      <div class="row">
       
      </div>
      <div class="row">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <form @submit.prevent="findRefund">
            <div class="card">
              <div class="card-body">
                <strong>{{this.currentLanguage ==='en'?'Find refund request':'ค้นหารายการขอคืนเงิน'}}</strong>
                <div class="media">
                  <div class="media-body">
                    <h6 class="f-w-500"> </h6>
                    <div class="row">
                      <div class="d-flex justify-content-center">
                        <figure class="col-12">
                          <img :src="this.s3_url+'event/'+this.$route.params.event_key+'/cover.jpg'"  style="width: 100%;box-shadow: 0em 0em 1em rgb(0 0 0 / 50%);border-bottom-left-radius: 0.2em;border-bottom-right-radius: 0.2em;border: 0px;" alt="Image description"
                            class="img-thumbnail" />
                        </figure>
                    </div>
                      <div class="col-sm-12">
                        <b>{{this.currentLanguage ==='en'?'Find refund request':'ตรวจสอบคำขอคืนเงิน'}}</b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <div class="form-check form-check-inline">
                        <input class="form-check-input" v-model="filter_type" checked required type="radio"
                          name="inlineRadioOptions" id="inlineRadio3" value="id_card">
                        <label class="form-check-label" for="inlineRadio3">
                          {{this.currentLanguage ==='en'?'Card No':'หมายเลขบัตรประชาชน'}}
                        </label>
                      </div>
                      <div class="form-check form-check-inline">
                        <input class="form-check-input" v-model="filter_type"  required type="radio"
                          name="inlineRadioOptions" id="inlineRadio1" value="mobile_no">
                        <label class="form-check-label" for="inlineRadio1">
                          {{this.currentLanguage ==='en'?'Mobile no':'หมายเลขโทรศัพท์'}}
                        </label>
                      </div>
                      <!-- <div class="form-check form-check-inline" v-if="this.$route.params.event_key != 'punpanrak-teechonburi-2026'">
                        <input class="form-check-input" v-model="filter_type" type="radio"  required name="inlineRadioOptions"
                          id="inlineRadio2" value="fname">
                        <label class="form-check-label" for="inlineRadio2">
                          {{this.currentLanguage ==='en'?'First name':'ชื่อผู้สมัคร(ชื่อเท่านั้น)'}}
                        </label>
                      </div> -->
                      
                    </div>
                      <div class="mb-12 col-sm-12">
                        <input
                          required
                          maxlength="15"
                          :minlength="this.filter_type==='mobile_no'?10:this.filter_type==='id_card'?8:4"
                          type="text"
                          class="form-control"
                          :placeholder="this.currentLanguage ==='en'? (this.filter_type==='mobile_no'?'Mobile no':this.filter_type==='fname'?'Frist name':'Card No/Passport') : (this.filter_type==='mobile_no'?'หมายเลขโทรศัพท์':this.filter_type==='fname'?'ชื่อผู้สมัคร(ชื่อเท่านั้น)':'หมายเลขบัตรประชาชน')"
                          v-model="txt_search"
                        />
                      </div>
                      
                    </div>
                  </div>
                </div>
                <div class="row">&nbsp;</div>
                <div class="row">
                  <div class="d-flex justify-content-center">
                    <button
                      type="submit"
                      style="cursor: pointer"
                      class="btn btn-primary btn-lg"
                    >
                     {{this.currentLanguage ==='en'?'Search':'ค้นหา'}}
                    </button>
                    &nbsp;
                    <button
                      style="cursor: pointer"
                      @click.prevent="clear_result"
                      type="reset"
                      class="btn btn-secondary btn-lg"
                    >
                      {{this.currentLanguage ==='en'?'Cancel':'ยกเลิก'}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="col-sm-1"></div>
      </div>

      <div class="row" v-if="this.start_search === 'true'">
        <div class="col-sm-1"></div>
        <div class="col-sm-10">
          <div class="card">
            <div class="card-body">
              <div v-if="this.is_searching === 'true'">
                <div class="d-flex justify-content-center">
                  <img width="60" src="../../assets/images/running_loading.svg" />
                </div>
              </div>

              <div
                v-if="!this.resultList.length && this.is_searching === 'false'"
              >
                <table class="table">
                  <thead>
                    <tr>
                      <th scope="col">{{this.currentLanguage ==='en'?'Registration date':'วันที่สั่งซื้อ'}}</th>
                      <th scope="col">{{this.currentLanguage ==='en'?'Status':'สถานะ'}}</th>
                      <th scope="col">{{this.currentLanguage ==='en'?'View application':'ดูคำสั่งซื้อ'}}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="10" style="text-align: center">
                        {{this.currentLanguage ==='en'?'Application not found':'ไม่พบข้อมูลคำสั่งซื้อ'}}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="this.resultList.length">
                <div class="table-responsive">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{this.currentLanguage ==='en'?'Order':'คำสั่งซื้อ'}}</th>
                        <th scope="col">{{this.currentLanguage ==='en'?'Status':'สถานะการขอคืนเงิน '}}</th>
                        <th scope="col">{{this.currentLanguage ==='en'?'Create':'วันที่ยื่นคำขอ'}}</th>
                        <th scope="col">{{this.currentLanguage ==='en'?'Create':'วันที่โอนคืนเงิน'}}</th>
                        <th scope="col">{{this.currentLanguage ==='en'?'Name':'ชื่อ-สกุล'}}</th>
                        <th scope="col">{{this.currentLanguage ==='en'?'Mobile phone':'หมายเลขโทรศัพท์'}}</th>
                        <th scope="col">{{this.currentLanguage ==='en'?'Type':'ประเภทการสมัคร'}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(src, index) in this.resultList" :key="index" >
                        <td v-if="src.refund_status === 'I'" style="font-size: xx-small;"> <a target="_blank" :href=" '/order/' + src.order_uuid"><button type="button" class="btn btn-warning btn-sm">ยื่นคำขอคืนเงิน</button></a></td>
                        <td v-if="src.refund_status === 'REQUEST' || src.refund_status === 'COMPLETED'" style="font-size: xx-small;"><a target="_blank" :href=" '/order/' + src.order_uuid"><u><b>{{ src.order_uuid }}</b></u></a></td>
                        <td v-if="src.refund_status === 'I'" style="color: red;font-size: xx-small;">{{this.currentLanguage ==='en'?'Waiting for request':'รอยื่นคำขอ'}}</td>
                        <td v-if="src.refund_status === 'REQUEST'" style="color: orange;font-size: xx-small;">{{this.currentLanguage ==='en'?'Request':'ส่งคำขอคืนเงิน'}}</td>
                         <td v-if="src.refund_status === 'COMPLETED'" style="color: green;font-size: xx-small;">{{this.currentLanguage ==='en'?'Completed':'โอนเงินคืนเรียบร้อย'}}</td>
                        <td style="font-size: xx-small;">{{ src.refund_create_date_txt || '-' }}</td>
                        <td style="font-size: xx-small;">{{ src.refund_completed_date_txt || '-' }}</td>
                        <td style="font-size: xx-small;">{{ src.fname }} {{ src.lname }}</td>
                        <td style="font-size: xx-small;">{{ src.mobile_no }}</td>
                        <td style="font-size: xx-small;">{{ src.run_type_name }}</td>    
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-sm-1"></div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { useHead } from '@vueuse/head'
import {computed, reactive } from 'vue'
export default {
  data() {
    return {
      email: "",
      txt_search: "",
      resultList: [],
      status: "",
      is_searching: "false",
      start_search: "false",
      currentLanguage: 'th',
      filter_type: "id_card",
      s3_url: process.env.VUE_APP_AWS_S3_URL
    };
  },
  setup() {
    useHead({
      title: computed(() => `ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH`),
      meta: [
        {
          name: `description`,
          content: computed(() => `'งานวิ่ง ระบบรับสมัครงานวิ่ง | RUNRACE.IN.TH'`),
        },
        {
          name: `keywords`,
          content: computed(() => `งานวิ่ง,ระบบรับสมัครงานวิ่ง,ค้นหาคำสั่งซื้อ,ค้นหารูปวิ่ง, หารูปวิ่ง,งานวิ่ง,runrace,runninghub,facesearch`),
        }
        ],
     
    })
  },
  async created(){
    this.currentLanguage = localStorage.getItem('currentLanguage');
  },
  methods: {
    async findRefund() {

    
      
      this.start_search = "true";
      this.resultList = [];
      this.is_searching = "true";

      
      const data = {
        tk: process.env.VUE_APP_FN_TO_BK_SECRET_KEY,
        event_key: this.$route.params.event_key,
        txt_search: this.txt_search,
        filter_type: this.filter_type
      };
      let result = await axios.post("/v1/order/event-refund", data);
      this.status = result.data.status;
      if (result.data.status === "success") {
        this.resultList = result.data.body;
      }
      this.is_searching = "false";
    },
    async clear_result() {
      this.start_search = "false";
      this.resultList = {};
      this.txt_search = "";
    },
  },
};
</script>